import React from 'react';
import PropTypes from 'prop-types';

import './PersonalHistoryList.scss';
import PersonalHistory from '../PersonalHistory/PersonalHistory';
import ArrowSVG from '../../../../SVGs/ArrowSVG/ArrowSVG';
import { personalHistoryShape } from '../../../../Includes/userProps';

export default class PersonalHistoryList extends React.PureComponent {
    constructor(props) {
        super(props);

        this.baseClassName =
            'component-Users-UserProfile-Modules-PersonalHistoryList';
        this.state = {
            isExpanded: false,
        };
    }

    static propTypes = {
        /**
         * list of serialized experiences or educations
         */
        serializedPersonalHistoryList: PropTypes.arrayOf(personalHistoryShape)
            .isRequired,
        /**
         * list of raw experiences or educations
         */
        rawPersonalHistoryList: PropTypes.array.isRequired,
        /**
         * how many items in the list to be displayed
         */
        collapseShowCount: PropTypes.number,
        /**
         * whether to show edit button nextg to personal history
         */
        showEditButton: PropTypes.bool,
        // function to update parent state with new list of histories
        updateHistoryList: PropTypes.func.isRequired,
    };

    static defaultProps = {
        serializedPersonalHistoryList: [],
        rawPersonalHistoryList: [],
        collapseShowCount: 3,
        showEditButton: false,
    };

    toggleIsExpanded = () => {
        this.setState({ isExpanded: !this.state.isExpanded });
    };

    render() {
        const { isExpanded } = this.state;
        const {
            serializedPersonalHistoryList,
            rawPersonalHistoryList,
            collapseShowCount,
            showEditButton,
            updateHistoryList,
        } = this.props;
        const totalCountLargerThanCollapseCount =
            serializedPersonalHistoryList.length > collapseShowCount;
        const isCollapse = !isExpanded && totalCountLargerThanCollapseCount;
        let formattedPersonalHistoryList = serializedPersonalHistoryList;

        if (isCollapse) {
            formattedPersonalHistoryList = serializedPersonalHistoryList.slice(
                0,
                collapseShowCount
            );
        }

        return (
            <div className={`${this.baseClassName}`}>
                {formattedPersonalHistoryList.map((item, index) => (
                    <PersonalHistory
                        updateHistoryList={updateHistoryList}
                        key={`${item.id}-${item.title}-${index}`}
                        personalHistory={item}
                        showEditButton={showEditButton}
                        rawPersonalHistoryList={rawPersonalHistoryList}
                    />
                ))}

                {isCollapse && (
                    <div
                        className="toggle-section"
                        onClick={this.toggleIsExpanded}
                    >
                        <span className="toggle-section__text">
                            {`Show ${
                                serializedPersonalHistoryList.length -
                                collapseShowCount
                            } more`}
                        </span>

                        <ArrowSVG
                            className="toggle-section__icon"
                            direction="down"
                        />
                    </div>
                )}
            </div>
        );
    }
}
